import { ComponentRenderProps } from '@json-render/react';
import {
  Card as ShadcnCard,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

type CardProps = ComponentRenderProps & {
  element: {
    props: {
      title: string | null;
      padding: 'sm' | 'md' | 'lg' | null;
    };
    children?: string[];
  };
};

const paddingMap = {
  sm: 'p-2',
  md: 'p-3',
  lg: 'p-4',
};

export function Card({ element, children }: CardProps) {
  const { title, padding } = element.props;
  const paddingClass = padding ? paddingMap[padding] : 'p-3';

  return (
    <ShadcnCard className={paddingClass}>
      {title && (
        <CardHeader className="p-0 pb-2">
          <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent className="p-0">{children}</CardContent>
    </ShadcnCard>
  );
}
